import { render } from "./Bit.vue?vue&type=template&id=1bae135e"
import script from "./Bit.vue?vue&type=script&lang=js"
export * from "./Bit.vue?vue&type=script&lang=js"

import "./Bit.vue?vue&type=style&index=0&id=1bae135e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__